<dx-popup
    #workOrderEditorPopup
    minWidth="150px"
    minHeight="150px"
    width="60%"
    height="75%"
    [title]="workOrderTitle"
    [showTitle]="true"
    [showCloseButton]="true"
    [shading]="false"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onShown)="onShown()"
    (onHidden)="onCloseClick()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box *ngIf="workOrderEditor" width="100%" height="100%" direction="col" class="editor-box-container">
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-form width="100%" height="100%" labelLocation="top" [colCount]="1">
                        <dxi-item itemType="group" [colCount]="2">
                            <dxi-item [isRequired]="true">
                                <dxo-label text="Community"></dxo-label>
                                <div *dxTemplate>
                                    <app-multi-column-selector
                                        #communitySelector
                                        [name]="'Community'"
                                        [readOnly]="isCommunityAvailable"
                                        [gridSource]="communityList"
                                        [boxValue]="communityBoxValue"
                                        [valueExpr]="'communityId'"
                                        [displayExpr]="'communityName'"
                                        [columnDef]="communityColumns"
                                        [dropDownButtonTemplate]="'dropDownButton'"
                                        [dropDownOptions]="{ width: 'auto' }"
                                        [showClearButton]="false"
                                        [placeholder]="'Select Community...'"
                                        [showHeaderFilters]="true"
                                        (gridSelectionEvent)="onCommunitySelection($event)"
                                    ></app-multi-column-selector>
                                </div>
                            </dxi-item>
                            <dxi-item>
                                <dxo-label text="Work Order #"></dxo-label>
                                <div *dxTemplate>
                                    <div class="input-container">
                                        <div class="input-content">
                                            <dx-text-box
                                                placeholder="New Work Order"
                                                [elementAttr]="{ class: 'text-content' }"
                                                [readOnly]="!workOrderInfo?.workOrderId"
                                                [(value)]="workOrderInfo.workOrderId"
                                            ></dx-text-box>
                                        </div>
                                        <div *ngIf="workOrderInfo?.workOrderId && isInternalUser" class="icon-content">
                                            <app-notes-icon
                                                cssClass="fa-2x"
                                                actionCode="MAINTENANCE_WORK_ORDERS"
                                                [hasNotes]="workOrderEditor?.hasNotes"
                                                (onNotesClick)="onNotesClick()"
                                            ></app-notes-icon>
                                            <!-- 
                                                Keeping the commented code for reference
                                                <ng-container *ngIf="workOrderEditor?.hasNotes">
                                                <i
                                                    title="Internal Notes"
                                                    class="cc-hyperlink cc-icon-check fa-2x"
                                                    [ngClass]="iconNotes"
                                                    (click)="onNotesClick()"
                                                ></i>
                                            </ng-container>
                                            <ng-container *ngIf="!workOrderEditor?.hasNotes">
                                                <i
                                                    title="Internal Notes"
                                                    class="cc-hyperlink fa-2x dx-theme-accent-as-text-color"
                                                    [ngClass]="iconEmptyNotes"
                                                    (click)="onNotesClick()"
                                                ></i>
                                            </ng-container>
                                            
                                            -->
                                        </div>
                                    </div>
                                </div>
                            </dxi-item>
                        </dxi-item>

                        <dxi-item itemType="group" [colCount]="2">
                            <dxi-item>
                                <dxo-label text="Created by"></dxo-label>
                                <div *dxTemplate>
                                    <dx-text-box [readOnly]="true" [value]="workOrderEditor.createdBy"></dx-text-box>
                                </div>
                            </dxi-item>
                            <dxi-item>
                                <dxo-label text="Date Created"></dxo-label>
                                <div *dxTemplate>
                                    <dx-date-box
                                        [readOnly]="true"
                                        [displayFormat]="dateFormat"
                                        [value]="workOrderEditor.createdDate"
                                    ></dx-date-box>
                                </div>
                            </dxi-item>
                        </dxi-item>
                    </dx-form>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate class="tab-panel-content">
                    <dx-tabs
                        *ngIf="workOrderInfo"
                        width="20%"
                        class="cc-tabs"
                        [dataSource]="tabItems"
                        [(selectedItem)]="selectedTabItem"
                    ></dx-tabs>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <div class="full-width full-height tab-content-border dx-theme-border-color">
                        <ng-container *ngIf="selectedTabItem.name === 'jobInfo'">
                            <app-work-order-editor-job-info
                                #workOrderEditorJobInfo
                                [workOrderEditor]="workOrderEditor"
                                [workOrderInfo]="workOrderInfo"
                                [customerId]="customerId"
                            ></app-work-order-editor-job-info>
                        </ng-container>
                        <ng-container *ngIf="selectedTabItem.name === 'jobDetails'">
                            <app-work-order-editor-job-detail
                                #workOrderEditorJobDetail
                                [workOrderEditor]="workOrderEditor"
                                [workOrderInfo]="workOrderInfo"
                            ></app-work-order-editor-job-detail>
                        </ng-container>
                    </div>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate class="toolbar-container">
                    <dx-toolbar>
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Manage Proposals"
                                    hint="Manage Proposals"
                                    [disabled]="!workOrderInfo.workOrderId"
                                    (onClick)="onManageProposalClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Manage Work Authorization"
                                    hint="Manage Work Authorization"
                                    [disabled]="!workOrderInfo.workOrderId"
                                    (onClick)="onManageWorkAuthorizationClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="Save"
                                    hint="Save"
                                    [disabled]="!workOrderInfo.communityId"
                                    [icon]="iconSave"
                                    (onClick)="onSaveWorkOrder()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="Save & Close"
                                    hint="Save & Close"
                                    [disabled]="!workOrderInfo.communityId"
                                    [icon]="iconSave"
                                    (onClick)="onSaveAndCloseWorkOrder()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Close"
                                    hint="Close"
                                    [icon]="iconClose"
                                    (onClick)="onCloseClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<app-work-orders-notes-editor
    *ngIf="showNotes"
    [communityId]="communityId"
    [workOrderId]="workOrderId"
    (onClose)="onNotesClose($event)"
></app-work-orders-notes-editor>

<app-work-order-email-attachment-selector
    *ngIf="showEmailAttachmentSelector"
    [emailCacheId]="emailCacheId"
    [attachments]="emailAttachments"
    [emailAccount]="emailAccount"
    (onAttachmentSelect)="onEmailAttachmentSelect($event)"
    (onClose)="onEmailAttachmentSelectorClose()"
></app-work-order-email-attachment-selector>

<cc-message-box #workOrderEditorMessageBox></cc-message-box>
